import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { SharedModule } from '../../shared/shared.module';
// import { ManualEntryConfiguratorComponent } from './manual-entry-configurator/manual-entry-configurator.component';
import { ProcessChartsModule } from '../spc/process-charts/process-charts.module';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule,
    ProcessChartsModule
  ]
})
export class MainModule { }
